
export default function BeforeAfter() {
  const before = [
    'Excel地獄で数字が追えない',
    '属人化で担当者に依存',
    'ミスが多発してクレーム対応',
    '時間が消失して本業に集中できない'
  ];

  const after = [
    '利益が見える化され判断が速い',
    '承認だけで業務が回る',
    'ミスが減りクレームも激減',
    '任せられる体制で時間を創出'
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            導入後の<strong className="text-primary">変化</strong>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-8">
          <div className="bg-gradient-to-br from-red-50 to-white rounded-2xl p-6 md:p-10 border-2 border-red-100">
            <div className="flex items-center gap-2 md:gap-3 mb-5 md:mb-8">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-red-500 text-white rounded-full flex items-center justify-center">
                <i className="ri-close-line text-xl md:text-2xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-gray-900">Before</h3>
            </div>
            
            <ul className="space-y-4 md:space-y-6">
              {before.map((item, index) => (
                <li key={index} className="flex items-start gap-3 md:gap-4">
                  <i className="ri-close-circle-line text-red-500 text-xl md:text-2xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm md:text-lg text-gray-800 leading-relaxed font-medium">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-6 md:p-10 border-2 border-green-100">
            <div className="flex items-center gap-2 md:gap-3 mb-5 md:mb-8">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-green-500 text-white rounded-full flex items-center justify-center">
                <i className="ri-check-line text-xl md:text-2xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-gray-900">After</h3>
            </div>
            
            <ul className="space-y-4 md:space-y-6">
              {after.map((item, index) => (
                <li key={index} className="flex items-start gap-3 md:gap-4">
                  <i className="ri-check-circle-line text-green-500 text-xl md:text-2xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm md:text-lg text-gray-800 leading-relaxed font-medium">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
